import client from "../client"

export const upsertBankAccount = async (payload) => {
  const body = {
    bank_code: "SHINHAN",
    account_number: payload.accountNumber.replace(/[^0-9]*/g, ""),
    account_holder_name: payload.accountHolderName,
  }

  const response = await client.post(`/users/bank/account`, body)

  return response.data
}
